import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, Transition as _Transition, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "folder-item" }
const _hoisted_2 = {
  ref: "folder-name",
  class: "folder-name"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-folder" }, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  ref: "showMenu",
  class: "folder-options-menu animated-fast"
}
const _hoisted_6 = {
  key: 0,
  class: "folder-children"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "children-dashed-border" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_Dataset = _resolveComponent("Dataset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ((_ctx.datasets.length > 0 || _ctx.children.length > 0) && _ctx.searchTerm.length === 0)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded)),
            class: _normalizeClass(["fa fa-caret-right", { expanded: _ctx.isExpanded }])
          }, null, 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onContextmenu: _cache[11] || (_cache[11] = _withModifiers(($event) => _ctx.toggleShowMenu('right', $event), ["prevent","right","stop","exact"])),
        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.isExpanded = !_ctx.isExpanded), ["exact"])),
        class: "folder-label",
        style: {"display":"flex","align-items":"center","height":"100%","width":"100%"}
      }, [
        _hoisted_3,
        (!_ctx.showFolderNameTruncatedTooltip)
          ? _withDirectives((_openBlock(), _createElementBlock("span", {
              key: 0,
              onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkShowNameTooltip && _ctx.checkShowNameTooltip(...args))),
              class: "folder-n",
              ref: "folderName"
            }, _toDisplayString(_ctx.name), 545)), [
              [_vShow, !_ctx.renaming]
            ])
          : (_openBlock(), _createBlock(_component_imdex_tooltip, {
              key: 1,
              containerStyles: {
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
						overflow: 'hidden'
					},
              nudgeX: _ctx.name.length
            }, {
              activator: _withCtx((show) => [
                _withDirectives(_createElementVNode("span", _mergeProps({
                  class: "folder-n",
                  ref: "folderName"
                }, _toHandlers(show), {
                  onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkShowNameTooltip && _ctx.checkShowNameTooltip(...args)))
                }), _toDisplayString(_ctx.name), 17), [
                  [_vShow, !_ctx.renaming]
                ])
              ]),
              tooltip: _withCtx(() => [
                _createElementVNode("span", { innerHTML: _ctx.name }, null, 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["nudgeX"])),
        _withDirectives(_createElementVNode("input", {
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitRenameFolder())),
          onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectRenameText && _ctx.selectRenameText(...args))),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newName) = $event)),
          onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.closeRenameInput()), ["enter"])),
          ref: "renameInput",
          type: "text",
          class: "rename-input"
        }, null, 544), [
          [_vModelText, _ctx.newName],
          [_vShow, _ctx.renaming]
        ]),
        _createElementVNode("i", {
          ref: "showMenuIcon",
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.toggleShowMenu()), ["stop"])),
          class: "fa fa-ellipsis-h show-menu-icon"
        }, [
          _createVNode(_Transition, {
            enterActiveClass: "zoomIn2",
            leaveActiveClass: "fadeOutDown"
          }, {
            default: _withCtx(() => [
              (_ctx.showMenu)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", {
                        onMousedown: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitImportIntoFolder(_ctx.name)))
                      }, _toDisplayString(_ctx.$t("ssa.hierarchy.import")), 33),
                      _createElementVNode("li", {
                        onMousedown: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleRename && _ctx.toggleRename(...args)), ["prevent"]))
                      }, _toDisplayString(_ctx.$t("ssa.hierarchy.rename")), 33),
                      _createElementVNode("li", {
                        onMousedown: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emitDeleteFolder(_ctx.name)))
                      }, _toDisplayString(_ctx.$t("ssa.hierarchy.delete")), 33)
                    ])
                  ], 512))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512)
      ], 32)
    ], 512),
    (_ctx.isExpanded || _ctx.searchTerm.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datasets, (dataset, d) => {
            return (_openBlock(), _createBlock(_component_Dataset, {
              onSetActiveDatasetType: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emitSetActiveDatasetType())),
              onDeleteDataset: _cache[14] || (_cache[14] = ($event: any) => (_ctx.emitDeleteDataset($event))),
              onRenameDataset: _cache[15] || (_cache[15] = ($event: any) => (_ctx.emitRenameDataset($event))),
              onMoveDataset: _cache[16] || (_cache[16] = ($event: any) => (_ctx.emitMoveDataset($event))),
              onSelect: _cache[17] || (_cache[17] = ($event: any) => (_ctx.emitSelect($event))),
              onHighlight: _cache[18] || (_cache[18] = ($event: any) => (_ctx.emitHighlight($event))),
              id: dataset.id,
              isDatasetTop: true,
              key: `${dataset.id}_${d}_${
					Object.values(dataset.paraviewLayersInfoSplit).find(
						(item) =>
							item.layerConfigType === _ctx.NonDrillholeLayerConfigTypeTmp ||
							item.layerConfigType === _ctx.CollarDrillholeLayerConfigTypeTmp
					)?.hierarchies.length
				}`,
              selected: _ctx.selected,
              highlighted: _ctx.highlighted,
              is: 'imdex-dataset',
              name: dataset.name,
              dataType: _ctx.dataType,
              status: dataset.status,
              searchTerm: _ctx.searchTerm,
              paraviewVisHierarchies: 
					Object.values(dataset.paraviewLayersInfoSplit).find(
						(item) =>
							item.layerConfigType === _ctx.NonDrillholeLayerConfigTypeTmp ||
							item.layerConfigType === _ctx.CollarDrillholeLayerConfigTypeTmp
					)?.hierarchies
				,
              groupName: _ctx.groupName
            }, null, 8, ["id", "selected", "highlighted", "name", "dataType", "status", "searchTerm", "paraviewVisHierarchies", "groupName"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}